<template>
  <div class="enrollfee-invoice-info-cell">
    <el-popover
      popper-class="enrollfee-invoice-info-popover"
      placement="top"
      width="400"
      trigger="click"
      v-model="visible">
      <div v-loading="loading">
        <template v-if="hasInvoiceInfo">
          <el-form label-width="120px" label-position="left">
            <el-form-item label="抬头类型：">
              <span>{{ rowData['invoiceTypeName'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="发票内容：" v-if="rowData['invoiceContentName']">
              <span>{{ rowData['invoiceContentName'] }}</span>
            </el-form-item>
            <el-form-item label="发票抬头：">
              <el-button
                v-if="rowData['invoiceTitle']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['invoiceTitle'])">
              </el-button>
              <span>{{ rowData['invoiceTitle'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="纳税人识别号：" v-if="rowData['invoiceTypeCode'] === '2'">
              <el-button
                v-if="rowData['taxpayerId']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['taxpayerId'])">
              </el-button>
              <span>{{ rowData['taxpayerId'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="公司地址：" v-if="rowData['invoiceTypeCode'] === '2'">
              <el-button
                v-if="rowData['companyAddress']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['companyAddress'])">
              </el-button>
              <span>{{ rowData['companyAddress'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="公司电话：" v-if="rowData['invoiceTypeCode'] === '2'">
              <el-button
                v-if="rowData['companyPhone']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['companyPhone'])">
              </el-button>
              <span>{{ rowData['companyPhone'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="开户银行：" v-if="rowData['invoiceTypeCode'] === '2'">
              <el-button
                v-if="rowData['bankName']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['bankName'])">
              </el-button>
              <span>{{ rowData['bankName'] || '未设置' }}</span>
            </el-form-item>
            <el-form-item label="银行账号：" v-if="rowData['invoiceTypeCode'] === '2'">
              <el-button
                v-if="rowData['bankAccount']"
                type="text"
                icon="el-icon-document-copy"
                class="copy-btn"
                @click="copyToClipboard(rowData['bankAccount'])">
              </el-button>
              <span>{{ rowData['bankAccount'] || '未设置' }}</span>
            </el-form-item>
          </el-form>
        </template>
        <template v-else>
          <div class="no-data-tip">暂无发票抬头信息</div>
        </template>
      </div>
      <span slot="reference" class="data" :class="hasInvoiceInfo ? '' : 'grid-cell-danger'">
        {{ displayText }}
        <span class="icon" v-if="hasInvoiceInfo"><i class="el-icon-view"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EnrollfeeInvoiceInfoCell',
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  computed: {
    // 判断是否有发票信息
    hasInvoiceInfo () {
      return this.rowData['invoiceTitle'] ||
             this.rowData['taxpayerId'] ||
             this.rowData['invoiceTypeName']
    },
    // 显示文本
    displayText () {
      if (this.hasInvoiceInfo) {
        return this.rowData['invoiceTitle'] || '查看详情'
      }
      return '未申请'
    }
  },
  methods: {
    // 复制到剪贴板
    copyToClipboard (text) {
      if (!text) {
        return
      }
      this.$copyText(text).then(() => {
        this.$notify({
          title: '复制成功',
          message: '内容成功复制到剪贴板',
          type: 'success'
        })
      }, () => {
        this.$message.error({
          message: '浏览器不支持复制',
          center: true
        })
      })
    }
  }
}
</script>

<style lang="scss">
@use '../../../../../../styles/color' as *;

.enrollfee-invoice-info-cell {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;

  .data {
    cursor: pointer;

    .icon {
      color: $set-primary-color;
      margin-left: 5px;
    }
  }
}

.enrollfee-invoice-info-popover {
  .el-form {
    .el-form-item {
      margin-bottom: 15px;

      span {
        word-break: break-all;
      }

      .copy-btn {
        margin-right: 10px;
        padding: 0;
        font-size: 12px;

        &:hover {
          color: $set-primary-color;
        }
      }
    }
  }

  .no-data-tip {
    text-align: center;
    padding: 20px;
    color: #909399;
  }
}
</style>
